import React from 'react'

export const LogoType = () => {

  return (
    <div style={styles.container()} id="logotype-container">
      <img src={process.env.PUBLIC_URL + "/logotype.svg"} alt={"Företagets logotyp"} className="logotype-image"/>
    </div>
  )
}

const styles = {
  container: () => ({
    display: 'flex', 
    justifyContent: 'center'
  })
}